export const getCheckboxRadius = (borderRadius: string): string => {
  if (!borderRadius) return '6px';

  try {
    const firstValue = borderRadius.split(' ')[0] || '';

    // Extract numeric value from the first part (e.g., "42px")
    const match = firstValue.match(/^(\d+)/);
    const borderRadiusValue = match ? Number.parseInt(match[1], 10) : Number.NaN;

    if (Number.isNaN(borderRadiusValue)) return '6px';
    const resolvedBorderRadius = Math.min(borderRadiusValue, 6);
    return `${resolvedBorderRadius}px`;
  } catch (error) {
    console.error('Error parsing border radius:', error);
    return '6px';
  }
};
